export default "__VITE_ASSET__BOeOrX8I__"